import { Routes } from "./routes/Routes";
// import { Payment } from "./components/Payment/PaymentFinal";

function App() {
    return (
        <div className="App">
            <Routes />
            {/* <Payment /> */}
        </div>
    );
}

export default App;
